import { isAxiosError } from "axios";
import { Action } from "redux";
import {
  PostPublishStatus,
  Publish,
  ServerError,
  ThunkAction,
} from "../types/index.js";
import { fetch } from "../utils/utils.js";
import { showAlert } from "./Alerts.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["GET_PUBLISH_SUCCESS", "POST_PUBLISH_SUCCESS"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type GetPublishSuccess = ActionBase<"GET_PUBLISH_SUCCESS"> & {
  publish: Publish;
};
type PostPublishSuccess = ActionBase<"POST_PUBLISH_SUCCESS"> & {
  publish: Publish;
};

export type PublishAction = GetPublishSuccess | PostPublishSuccess;

export const isPublishAction = (action: Action): action is PublishAction =>
  isActionType(action, ActionTypeKeys);

export const getPublishStatus =
  ({
    siteId,
    showLastResult,
  }: {
    siteId: string;
    showLastResult: boolean;
  }): ThunkAction<Promise<GetPublishSuccess>> =>
  async (dispatch) => {
    const { data } = await fetch({ dispatch }).get<Publish>(
      `sites/${siteId}/publish`,
      { params: { showLastResult } },
    );
    return dispatch(getPublishSuccess(data));
  };

const getPublishSuccess = (publish: Publish): GetPublishSuccess => ({
  type: "GET_PUBLISH_SUCCESS",
  publish,
});

export const postPublish =
  (siteId: string): ThunkAction<Promise<PostPublishStatus>> =>
  async (dispatch) => {
    try {
      const { data } = await fetch({ dispatch }).post<Publish>(
        `sites/${siteId}/publish`,
      );
      dispatch(postPublishSuccess(data));
      return "success";
    } catch (error) {
      const isCriticalIssuesError =
        isAxiosError<ServerError>(error) &&
        error.response?.data.error === "critical errors found";

      if (isCriticalIssuesError) return "criticalIssues";

      dispatch(
        showAlert(
          "Beim Veröffentlichen der Seite ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut, oder wenden Sie sich an den Support!",
        ),
      );
      throw error;
    }
  };

const postPublishSuccess = (publish: Publish): PostPublishSuccess => ({
  type: "POST_PUBLISH_SUCCESS",
  publish,
});
